<template>
  <div>
    <div :class="{'modal':true, 'show':showModal}">
      <div class="bg-overlay" @click="closeModal"></div>
      <div class="modal-content">
        <input type="text" placeholder="Search a country..." v-model="searchString" @keyup="filter">
        <div class="country-list">
          <div class="country-name" v-for="(country, index) in countryList" @click="selectCountry(index)" v-if="country.dialCode">
            <div v-bind:class="['iti-flag ' + country.code]"></div>
            <span class="country-code"> {{ country.name }} </span>
            <span class="name" v-if="!countryOnly"> (+{{ country.dialCode }}) </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {countries} from 'country-data'
const countryData = require('@/data/countries')

export default {
  name: 'country-code-modal',
  data(){
    return {
      searchString: '',
      countryOnly: this.$store.state.countryCode.countryOnly
    }
  },
  computed: {
    countryList: {
      get: function () { return this.$store.state.countryCode.countryList },
      set: function (value) {
        this.$store.commit('countryCode/setCountryList', value)
      }
    },
    showModal() { return this.$store.state.countryCode.countryModal }
  },
  methods: {
    closeModal() {
      this.searchString = ''
      this.sortCountries()
      this.$store.commit('countryCode/setCountryModal', false)
    },
    filter () {
      let queryString = this.searchString
      if (queryString === '') {
        this.sortCountries()
        return
      }

      let regex = new RegExp('^' + queryString, 'i')
      let result = []
      let allCountries = Object.values(countryData)

      for (let i = 0; i < allCountries.length; i++) {
        if (!regex.test(allCountries[i].name)) {
          continue
        }

        result.push(allCountries[i])
      }

      this.countryList = result
    },
    selectCountry (index) {
      let country = this.countryList[index]
      this.$store.commit('countryCode/setCountryName', country.name)
      this.$store.commit('countryCode/setCountryAlias', country.code)
      this.$store.commit('countryCode/setCallingCode', country.dialCode)
      this.closeModal()
    },
    sortCountries() {
      let country = Object.values(countryData)
      let displayCountry = []
      country = country.sort((a, b) => (a.name > b.name) ? 1 : -1)

      let topCountries = ['us', 'ca', 'gb']
      topCountries.forEach(x => {
        displayCountry.push(...country.filter(y=> y.code === x))
      })
      topCountries.forEach(x => {
        country = country.filter(y=> y.code !== x)
      })
      displayCountry.push(...country)

      this.countryList = displayCountry
    }
  },
  mounted() {
    this.sortCountries()
  }
}
</script>

<style lang="scss" scoped>
.modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0, .5);
  display: none;
  z-index: 12;

  .bg-overlay{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
  }

  .modal-content{
    position: absolute;
    top: 20%;
    left: 50%;
    width: 400px;
    padding: 25px;
    background: #fff;
    text-align: center;
    border-radius: 6px;
    margin-left: -200px;
    box-shadow: 1px 1px 5px 2px rgba(0,0,0, .3);
    display: none;

    input {
      margin-top: 0;
    }

    .country-list {
      height: 400px;
      text-align: left;
      overflow-y: auto;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);

      .country-name {
        padding: 10px 15px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        border-left: 1px solid rgba(0, 0, 0, 0.1);
        border-right: 1px solid rgba(0, 0, 0, 0.1);

        .iti-flag {
          display: inline-block;
        }

        &:hover {
          background-color: #fff8dc;
          cursor: pointer;
        }
      }
    }

  }
  &.show{
    display: block;

    .modal-content{
      display: block;
      -webkit-animation: slide-down .3s ease-out;
      -moz-animation: slide-down .3s ease-out;
    }
  }
}

@-webkit-keyframes slide-down {
  0% { opacity: 0; -webkit-transform: translateY(100%); }
  100% { opacity: 1; -webkit-transform: translateY(0); }
}
@-moz-keyframes slide-down {
  0% { opacity: 0; -moz-transform: translateY(100%); }
  100% { opacity: 1; -moz-transform: translateY(0); }
}
</style>



// WEBPACK FOOTER //
// src/components/App/CountryCodeModal.vue